module.exports = __webpack_public_path__ + "static/media/YDJS-PL.64eea586.pdf";